<template>
  <div class="container-fluid mt-4" style="max-width: 800px">
    <b-card title="Update User">
      <form v-if="model" @submit.prevent="saveUser">
        <b-form-group label="Username" label-align-sm="left">
          <b-form-input type="text" v-model="model.username" id="create-user-email" disabled/>
        </b-form-group>
        <b-form-group label="Password" label-align-sm="left">
          <b-form-input type="password" v-model="model.password" id="create-user-pwd" autocomplete="off"/>
        </b-form-group>
        <hr/>
        <b-form-group label="First Name" label-align-sm="left">
          <b-form-input type="text" v-model="model.first_name" id="create-user-first-name"/>
        </b-form-group>
        <b-form-group label="Last Name" label-align-sm="left">
          <b-form-input type="text" v-model="model.last_name" id="create-user-last-name"/>
        </b-form-group>
        <b-form-group label="Phone Number" label-align-sm="left">
          <b-form-input type="text" v-model="model.phone_number" id="create-user-phone"/>
        </b-form-group>
        <hr/>
        <b-form-group label="Role" label-align-sm="left">
          <b-form-select v-model="model.role" :options="roleOptions" id="create-user-role" :disabled="(this.user.role != 'admin' && this.user.role != 'customer-admin')"/>
        </b-form-group>
        <b-form-group label="Tags" label-align-sm="left">
          <b-form-input type="text" v-model="model.tags" id="create-user-tags"/>
        </b-form-group>
        <b-form-group v-if="model.role === 'booking-customer'" label="Primary Contact Organization" label-align-sm="left">
          <b-form-input type="text" v-model="model.primary_contact_organization" id="create-user-primary-contact-org" placeholder="Must match TBN booking PrimaryContactOrganization (comma-separated for multiple)"/>
        </b-form-group>
        <b-form-group v-if="model.role === 'booking-customer'" label="Home Page" label-align-sm="left">
          <b-form-input type="text" v-model="model.home_page" id="create-user-home-page" placeholder="/booking-customer"/>
        </b-form-group>
        <b-form-group label="Job Title" label-align-sm="left">
          <b-form-input type="text" v-model="model.job_title" id="create-user-tags"/>
        </b-form-group>
        <b-form-group label="Company/Location" label-align-sm="left">
          <b-form-input type="text" v-model="model.company_location" id="create-user-tags"/>
        </b-form-group>
        <span v-if="this.user.tenant == 'dattco-413f464d'">
        <b-form-group label="Employment Status" label-align-sm="left">
          <b-form-select
            v-model="model.employment_status"
            :options="employmentStatusOptions"
            id="create-user-employment_status"
          />
        </b-form-group>
        <b-form-group label="TBN Driver ID" label-align-sm="left">
          <b-form-input
            type="text"
            v-model="model.tbn_driver_id"
            id="create-user-tbn_driver_id"
          />
        </b-form-group>
        </span>
        <div>
          <b-btn type="submit" variant="success" id="create-user-submit">Save</b-btn>
          &nbsp;&nbsp;
          <b-btn v-if="(user.role == 'admin' || user.role == 'customer-admin')" :to="{ name: 'user_list'}">Cancel</b-btn>
        </div>
      </form>
    </b-card>
  </div>
</template>

<script>

import {get_user, update_user} from '../networking/apis'
import {mapState} from "vuex";

export default {
  name: 'user_detail',
  components: {  },
  data () {
    return {
      model: {},
      roleOptions: [
        { value: 'customer-admin', text: 'Admin' },
        { value: 'customer', text: 'Staff' },
        { value: 'booking-customer', text: 'Booking Customer' },
        { value: 'driver', text: 'Driver' },
        { value: 'customer-care', text: 'Customer Care' },
        { value: 'manager', text: 'Manager' },
        { value: 'dispatch', text: 'Dispatch' },
        { value: 'garage', text: 'Garage' },
        { value: 'wash-bay', text: 'Wash Bay' },
        { value: 'driver-bid-driver', text: 'Driver Bid Driver'},
        { value: 'other', text: 'Other' },
      ],
      employmentStatusOptions: [
        {value: 'full', text: 'Full Time'},
        {value: 'part', text: 'Part Time'},
        {value: 'casual', text: 'Casual'}
      ]
    }
  },
  async created() {
    await this.load_data()
  },
  methods: {
    async load_data() {
      try {
        if (this.$route.query.username) {
          //const decodedEmail = decodeURIComponent(this.$route.query.username);
          const {value: {data: user_data = []}} = (await get_user(this.user.tenant, this.$route.query.username))
          this.model = user_data
        }
      } catch(e) {
        this.$emit('showAlert', 'error retrieving data, try logging in again or contact support if needed', 'danger', 5000)
      }
    },
    async saveUser () {
      try{
        this.$emit('showAlert', "waiting for response...", 'info')
        const { message, status_code } = await update_user(this.user.tenant, this.model)
        this.$emit('showAlert', message || 'Success!', 'success', 1500)
        if (this.user.role == 'admin' || this.user.role == 'customer_admin')
          this.$router.push({name:'user_list'})
      } catch(e) {
        this.$emit('showAlert', 'error updating data, try logging in again or contact support if needed', 'danger', 5000)
      }
    }
  },
  computed:{
    ...mapState({
      user: state => state.profile.user
    }),
  },
  watch: {
    user: {
      deep: true,
      handler() {
        this.load_data()
      }
    }
  }
}
</script>
